var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 28 28"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M21.875 13.125a8.75 8.75 0 1 1-17.5 0 8.75 8.75 0 0 1 17.5 0m-1.97 8.018a10.46 10.46 0 0 1-6.78 2.482c-5.799 0-10.5-4.701-10.5-10.5s4.701-10.5 10.5-10.5 10.5 4.701 10.5 10.5c0 2.585-.934 4.95-2.482 6.78l4.85 4.851a.875.875 0 1 1-1.237 1.238z",
  clipRule: "evenodd"
})));
export default SvgIconSearch;